import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import PaperImage from "src/modules/3rd-party-management/assets/images/paper.svg";
import { Table } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import {
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const News = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const dateUtils = new DateUtils();
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const rows = data?.news || [];

    if (!hasNonEmptyArray(rows)) {
        return null;
    }

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('news')}
            className={activeAccordion === 'news' ? 'active' : ''}
            eventKey={'news'}
        >
            <Accordion.Header>
                <img src={PaperImage} alt="" />
                <span>{t('News')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Date')}</th>
                                <th>{t('Title')}</th>
                                <th>{t('Source')}</th>
                                <th>{t('Link')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={row.id || index}>
                                    <td>
                                        {row.publication_date
                                            ? dateUtils.convertDateToDate(row.publication_date, INTERNATIONAL_DATE_FORMAT)
                                            : '-'}
                                    </td>
                                    <td>{row.title || '-'}</td>
                                    <td>{row.source || '-'}</td>
                                    <td>
                                        {row.url ? (
                                            <a href={row.url} target="_blank" rel="noopener noreferrer">
                                                {t('Open')}
                                            </a>
                                        ) : '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(News);
